import "./footer.css";
const Footer = () => {
  return (
    <>
      <footer>
        <p>&copy; Easy Coding</p>
      </footer>
    </>
  );
};
export default Footer;
